import { propsSenzaPermesso } from "@/shared/auth/permessi";
import { giornoMese, type RitiroMancato } from "../api";

type Props = { mancato: RitiroMancato; onRiprenota: (m: RitiroMancato) => void; puo: boolean };

/** Il corriere non ha preso tutti gli ordini: lo si dice in cima alla scheda,
 *  con gli ordini rimasti e il tasto per riprenotarli. */
export function BannerMancato({ mancato, onRiprenota, puo }: Props) {
  const tipo = mancato.parziale ? "parziale" : "mancato";
  const n = mancato.lasciati.length;
  return (
    <div
      role="alert"
      className="mx-5 mt-3 flex items-start justify-between gap-4 rounded-lg bg-red-soft px-3 py-2.5 text-[12.5px] text-ink"
    >
      <div>
        <p className="font-extrabold">
          Ritiro del {giornoMese(mancato.data_ritiro)} {tipo}
        </p>
        <p>
          {n} {n === 1 ? "ordine" : "ordini"} su {mancato.totali} senza scansione del corriere:{" "}
          <span className="tabular-nums">
            {mancato.lasciati.map((o) => o.reference).join(", ")}
          </span>
        </p>
      </div>
      <button
        type="button"
        onClick={() => onRiprenota(mancato)}
        {...propsSenzaPermesso(puo, "spedizioni")}
        className="shrink-0 rounded-full border border-ink bg-card px-3 py-1.5 font-bold hover:bg-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 disabled:cursor-not-allowed"
      >
        Riprenota
      </button>
    </div>
  );
}
